import React, { createContext, useReducer, useCallback } from "react";
import axios from "../../axios";
import { ToastContainer } from "react-toastify";

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_STAMPS":
        return {
            ...state,
            stamps: action.payload.data,
            total: action.payload.total,
            pagination: action.payload.pagination,
        };

    default:
      return state;
  }
};

const StampContext = createContext({
  stamps: [],
  total: 0,
  pagination: {},
  GetStamps: () => {},
  GetStamp: () => {},
  GetDocumentUrl: ()  => {},
  AddStamp: () => {},
  UpdateStamp: () => {},
  DeleteStamp: () => {},
});

export const StampProvider = ({ children }) => {
  const initialState = {
    stamps: [],
    total: 0,
    pagination: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const GetStamps = useCallback(
    async ({ keyword = "", status = [], page = 1, limit = 10 } = {}) => {
      try {
        const params = new URLSearchParams();

        if (keyword) params.append("keyword", keyword);

        if (status.length) {
          status.forEach((item) => params.append("status", item));
        }

        params.append("page", page);
        params.append("limit", limit);

        const res = await axios.get(
          `${process.env.REACT_APP_TRANSACTIONS}stamps?${params.toString()}`
        );

        if (res.data.success) {
            dispatch({
                type: "SET_STAMPS",
                payload: {
                data: res.data.payload,
                total: res.data.pagination.total_items,
                pagination: res.data.pagination,
                },
            });
        }

        return res.data;
      } catch (err) {
        console.error(err);

        return {
          success: false,
          payload: [],
          pagination: {
            total_items: 0,
            total_pages: 1,
            current_page: 1,
          },
        };
      }
    },
    []
  );

  const GetStamp = useCallback(async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_TRANSACTIONS}stamps/${id}`
      );

      return res.data;
    } catch (err) {
      console.error(err);

      return {
        success: false,
        message: "Failed to get stamp.",
      };
    }
  }, []);

  const GetDocumentUrl = useCallback(async (id, type) => {
    return axios.get(
      `${process.env.REACT_APP_TRANSACTIONS}stamps/${id}/view`,
      {
        params: { type },
        responseType: "blob",
      }
    );
  }, []);

  const AddStamp = useCallback(async (payload) => {
    try {
        const formData = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (value instanceof File) {
            formData.append(key, value);
        } else {
            formData.append(key, value);
        }
        });

        const res = await axios.post(`${process.env.REACT_APP_TRANSACTIONS}stamps`,formData,
        {
            headers: {
            "Content-Type": "multipart/form-data",
            },
        }
        );

        return res.data;
    } catch (err) {
        console.error(err);

        return {
            success: false,
            message: "Failed to create stamp.",
        };
    }
    }, []);

  const UpdateStamp = useCallback(async (id, payload) => {
    try {
      const formData = new FormData();

      formData.append("stamp_title", payload.stamp_title);
      formData.append("stamp_number", payload.stamp_number);
      formData.append(
        "stamp_effective_date",
        payload.stamp_effective_date
      );
      formData.append("stamp_type", payload.stamp_type);

      if (payload.stamp_replace_number) {
        formData.append(
          "stamp_replace_number",
          payload.stamp_replace_number
        );
      }

      if (payload.stamp_replace_date) {
        formData.append(
          "stamp_replace_date",
          payload.stamp_replace_date
        );
      }

      // file baru
      if (payload.attachment) {
        formData.append(
          "attachment",
          payload.attachment
        );
      }


      const res = await axios.put(
        `${process.env.REACT_APP_TRANSACTIONS}stamps/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return res.data;

    } catch (err) {

      console.error(err);

      return {
        success: false,
        message: "Failed to update stamp.",
      };
    }
  }, []);

  const DeleteStamp = useCallback(async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_TRANSACTIONS}stamps/${id}`
      );

      return res.data;
    } catch (err) {
      console.error(err);

      return {
        success: false,
        message: "Failed to delete stamp.",
      };
    }
  }, []);

  return (
    <StampContext.Provider
      value={{
        stamps: state.stamps,
        total: state.total,
        pagination: state.pagination,
        GetStamps,
        GetStamp,
        GetDocumentUrl,
        AddStamp,
        UpdateStamp,
        DeleteStamp,
      }}
    >
      {children}
      <ToastContainer position="top-right" />
    </StampContext.Provider>
  );
};

export default StampContext;